import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useHistory, useParams } from 'react-router-dom';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import styled from 'styled-components';
import { deleteVeiculo, getVeiculoById } from '@spark/services/frotas';
import { notification } from '@spark/ui-components/utils/notification';
import CadastrosVeiculoMain from '../Cadastro';

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Titulo = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

const Subtitulo = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 14px;
  color: #6c757d;
`;

const VeiculoDetalhes = () => {
  const history = useHistory();
  const { id } = useParams();

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [resumo, setResumo] = useState({ frota: '', placa: '' });

  useEffect(() => {
    let ativo = true;

    const carregarResumo = async () => {
      try {
        const resposta = await getVeiculoById(id);
        if (!ativo) return;

        const veiculo = resposta?.veiculo ?? resposta?.Veiculo ?? resposta ?? {};
        setResumo({
          frota: veiculo.frota ?? veiculo.Frota ?? '',
          placa: veiculo.placa ?? veiculo.Placa ?? '',
        });
      } catch (error) {
        console.error('Erro ao carregar veiculo:', error);
      }
    };

    carregarResumo();
    return () => {
      ativo = false;
    };
  }, [id]);

  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleEditar = useCallback(() => {
    history.push(`/pages/veiculos/editar/${id}`);
  }, [history, id]);

  const handleExcluir = useCallback(async () => {
    const identificador = resumo.placa || resumo.frota || id;

    if (!window.confirm(`Tem certeza que deseja excluir o veiculo ${identificador}?`)) {
      return;
    }

    try {
      setDeleteLoading(true);
      await deleteVeiculo(id);
      notification.success('Veiculo excluido com sucesso!');
      history.push('/pages/veiculos');
    } catch (error) {
      console.error('Erro ao excluir veiculo:', error);
      notification.error('Nao foi possivel excluir o veiculo.');
    } finally {
      setDeleteLoading(false);
    }
  }, [history, id, resumo]);

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Inicio' },
              { name: 'Veiculos', route: '/pages/veiculos' },
              { name: 'Detalhes' },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <div>
                  <Titulo>Detalhes do Veiculo</Titulo>
                  {resumo.placa ? <Subtitulo>{resumo.placa}</Subtitulo> : null}
                </div>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                  <ButtonWithLoading
                    variant="outline-danger"
                    onClick={handleExcluir}
                    loading={deleteLoading || undefined}
                  >
                    Excluir
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>
              <CadastrosVeiculoMain isReadOnly id={id} hideHeader />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VeiculoDetalhes;
